import { memo } from 'react'
import { NodeProps, useReactFlow } from 'reactflow'
import { useShallow } from 'zustand/react/shallow'

import { NodeTypeEnum, PanelEnum } from '@ui/interfaces'
import { useNavigateToNode } from '@ui/lib/hooks/useNavigateToNode'
import { FeatureFlagName, useFeatureFlag } from '@ui/providers/FeatureFlagProvider'
import { useNodeAndEdgeStore } from '@ui/stores'
import { useLayoutPanelManagerStore } from '@ui/stores/pipelinesWorkflow'

import { LayoutPanel, RIGHT_PANEL_CONTENT } from '../PipelineLayoutManager'
import { NodeContainer } from './NodeContainer'
import { NodeContainerV2 } from './NodeContainerV2'

export const ExportNode = memo((node: NodeProps) => {
  const workflowUpdateEnabled = useFeatureFlag(FeatureFlagName.WorkflowUpdate)

  const { fitView } = useReactFlow()
  const navigateToNode = useNavigateToNode()

  const { setDisplayModal, currentNodeId, setCurrentNodeId, nodes } = useNodeAndEdgeStore(
    useShallow((state) => ({
      setDisplayModal: state.setDisplayModal,
      currentNodeId: state.currentNodeId,
      setCurrentNodeId: state.setCurrentNodeId,
      nodes: state.nodes,
    }))
  )

  const { setPanelContent } = useLayoutPanelManagerStore(
    useShallow((state) => ({
      setPanelContent: state.setPanelContent,
    }))
  )

  const nodeIsSelected = currentNodeId === node.id

  const onClick = () => {
    setCurrentNodeId(node.id)

    const currentNode = nodes.find((n) => n.id === node.id)
    fitView({ nodes: [currentNode!], duration: 400, maxZoom: 0.85, padding: 1.5 })

    if (workflowUpdateEnabled) {
      setPanelContent({
        panel: LayoutPanel.RIGHT_PANEL,
        content: RIGHT_PANEL_CONTENT.DESTINATIONS,
        open: true,
      })
      navigateToNode(node.id)
    } else {
      setDisplayModal(PanelEnum.DESTINATIONS)
    }
  }

  if (workflowUpdateEnabled) {
    return (
      <NodeContainerV2 nodeIsSelected={nodeIsSelected} nodeType={NodeTypeEnum.EXPORT} node={node} onClick={onClick} />
    )
  } else {
    return (
      <NodeContainer nodeIsSelected={nodeIsSelected} nodeType={NodeTypeEnum.EXPORT} node={node} onClick={onClick} />
    )
  }
})
